export const awardsData = [
  {
    title: 'Winner – NUS LifeHack 2022',
    description: 'Awarded first place in Singapore’s largest student-run hackathon.',
  },
  {
    title: 'Winner – SoC Venture Initiation Program',
    description:
      'Awarded $10,000 to fund promising student startups in NUS. Also a finalist in Singapore’s Junior Achievement $15,000 grant for startup ideation and prototyping.',
  },
  {
    title: 'Recognition from the Minister of Education, Singapore',
    description: 'Awarded a plaque in recognition of a web workflow automation system developed for Diabetes Singapore.',
  },
  {
    title: 'Recipient of the GIC Computing Fellowship',
    description:
      'This award supports students participating in the Computing for Voluntary Welfare Organizations (“CVWO”) attachment programme, which enables undergraduates to apply their skills in assisting voluntary welfare organisations (VWOs) better serve the community.',
  },
  {
    title: 'Top 100 – Google Solutions Challenge 2023',
    description:
      'An international competition to develop technology addressing the UN’s Sustainable Development Goals, selected from over 2,000 global teams.',
  },
  {
    title: 'Winner – Singapore Airlines AppChallenge 2022',
    description: 'Recognized for creating the best technology to revolutionize air travel, work, and lifestyle experiences.',
  },
  {
    title: 'Top 10 – Credit Suisse Code Challenge 2022',
    description: 'An inter-university coding competition focused on algorithmic problem-solving in a full-stack environment.',
  },

  {
    title: 'Finalist – Google Developer Student Clubs (NUS)',
    description: 'Finalist in the Annual Hackathon 2022 focused on technology for social good.',
  },
];
